export const styles = (theme) => ({
  link: {
    color: theme.palette.textColor.blue,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  empty: {
    color: theme.palette.textColor.secondary,
  },
});
